
export enum BusSaleQtyOption {
  unknown= 'unknown',
  NUMBER_0= '0',
  '1-2'= '1-2',
  '2-5'= '2-5',
  '5-10'= '5-10',
  '10-20'= '10-20',
  '>20'= '>20',

}